import "core-js/modules/es6.object.assign";
import { getSecondaryRangeChannel } from '../../channel';
import { getFieldOrDatumDef } from '../../channeldef';
import { ScaleType } from '../../scale';
import { keys } from '../../util';
import { formatSignalRef } from '../format';
export function labels(model, channel, specifiedLabelsSpec) {
  var _a;

  var encoding = model.encoding,
      config = model.config;
  var fieldOrDatumDef = (_a = getFieldOrDatumDef(encoding[channel])) !== null && _a !== void 0 ? _a : getFieldOrDatumDef(encoding[getSecondaryRangeChannel(channel)]);
  var axis = model.axis(channel) || {};
  var format = axis.format,
      formatType = axis.formatType;
  var text = formatSignalRef({
    fieldOrDatumDef: fieldOrDatumDef,
    field: 'datum.value',
    format: format,
    formatType: formatType,
    config: config,
    isUTCScale: model.getScaleComponent(channel).get('type') === ScaleType.UTC,
    omitTimeFormatConfig: true,
    omitNumberFormatAndEmptyTimeFormat: true // no need to generate number format for encoding block as we can use Vega's axis format

  });
  var labelsSpec = Object.assign(Object.assign({}, text ? {
    text: text
  } : {}), specifiedLabelsSpec);
  labelsSpec = Object.assign(Object.assign({}, labelsSpec), specifiedLabelsSpec);
  return keys(labelsSpec).length === 0 ? undefined : labelsSpec;
}